import React, { useState } from "react"
import { EMediaTypes, ICategory } from "../../../gatsby-graphql"
import CategoriesBar from "../../components/categories-bar"
import MediaPreview from "../../components/media-preview"
import Modal from "../../components/modal/modal"
import { SectionProps } from "../section-loader"
import { getMediaItems, getMediaType } from "../../helpers/get-media"
import {
  Container,
  ContentWrapper,
  SectionWrapper,
  ModalImage,
  ModalVideo,
  Wrapper,
} from "./media-elements"

interface IOpenedItem {
  url: string
  type: EMediaTypes
}

interface MediaProps extends SectionProps {
  data: {
    heading?: string
    count?: number
    categories?: ICategory[]
  }
}

const Media = ({ data, locale }: MediaProps) => {
  const [openedItem, setOpenedItem] = useState<IOpenedItem | null>(null)
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null)

  const media = getMediaItems({
    count: data.count,
    locale: locale,
    categorySlug: selectedCategory,
  })

  const onSelectedCategory = (
    e: React.MouseEvent<HTMLAnchorElement>,
    category: string | null
  ) => {
    e.preventDefault()
    if (category !== selectedCategory) {
      setSelectedCategory(category)
    }
  }

  return (
    <>
      <SectionWrapper>
        {data.categories && data.categories.length > 0 && (
          <CategoriesBar
            data={data.categories}
            basePath={`#`}
            active={selectedCategory}
            onClick={onSelectedCategory}
          />
        )}
        <ContentWrapper>
          <Container>
            {media.map(item => {
              const type = getMediaType(item.asset?.mime as string)
              return (
                <Wrapper key={item.id}>
                  <MediaPreview
                    type={type}
                    title={item.title as string}
                    description={item.description as string}
                    thumbUrl={item.thumbnail?.url as string}
                    fileUrl={item.asset?.url as string}
                    onClick={() =>
                      setOpenedItem({
                        url: item.asset?.url as string,
                        type: type,
                      })
                    }
                  />
                </Wrapper>
              )
            })}
          </Container>
        </ContentWrapper>
      </SectionWrapper>
      <Modal opened={!!openedItem} onClose={() => setOpenedItem(null)}>
        {openedItem?.type !== "VIDEO" ? (
          <ModalImage src={openedItem?.url} />
        ) : (
          <ModalVideo controls autoPlay src={openedItem?.url} />
        )}
      </Modal>
    </>
  )
}

export default Media
